import { Button, Card, Form, Input, Row, Typography, message } from "antd";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate, useParams } from "react-router-dom";
import { LoginContainer } from "../../components";
import HTTPClient from "../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export default function ResetPassword({}) {
    const navigate = useNavigate();
    const { token } = useParams();
    const { t } = useTranslation();

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    const resetPassword = async (values) => {
        const { password, conf_password } = values;
        if (password !== conf_password) {
            message.error(t("reset_password.different_passwords"));
            return;
        }

        HTTPClient.post("/auth/reset_password", { password, token })
            .then((res) => {
                message.success(t("reset_password.success"));
                navigate("/login");
            })
            .catch((e) => {
                message.error(t("reset_password.error"));
            });
    };

    return (
        <LoginContainer>
            <Row justify="center" align="middle" style={{ marginBottom: "3.5em" }}>
                <Text
                    style={{
                        color: "#fff",
                        font: '"Open Sans", sans-serif"',
                        letterSpacing: "-0.2px",
                        fontSize: "1.5rem",
                    }}>
                    {t("reset_password.title")}
                </Text>{" "}
            </Row>
            <Row justify="center" align="middle">
                <Card
                    bodyStyle={{ padding: 0 }}
                    style={{
                        minWidth: isLargeScreen ? "26rem" : "90%",
                        maxWidth: !isLargeScreen ? "90%" : "",
                        padding: "2.25rem 1.75rem 1.25rem 1.75rem",
                        marginBottom: "3rem",
                    }}>
                    <Form
                        validateTrigger="onSubmit"
                        name="basic"
                        onFinish={resetPassword}
                        autoComplete="off"
                        style={{ padding: "0px" }}>
                        <Form.Item
                            name="password"
                            rules={[
                                { required: true, message: t("reset_password.password_error") },
                            ]}>
                            <Input.Password placeholder={"Password"} style={{ height: "3rem" }} />
                        </Form.Item>

                        <Form.Item
                            name="conf_password"
                            rules={[
                                { required: true, message: t("reset_password.conf_password") },
                            ]}>
                            <Input.Password
                                placeholder={t("reset_password.conf_password")}
                                style={{ height: "3rem" }}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    display: "inline-block",
                                    width: "100%",
                                    height: "3.125rem",
                                    borderRadius: "1.5rem",
                                    color: "#fff",
                                    font: ' 700 0.875rem/0 "Open Sans", sans-serif',
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                }}>
                                {t("reset_password.call_to_action")}
                            </Button>
                        </Form.Item>
                    </Form>
                    <div style={{ textAlign: "center" }}>
                        <Text
                            style={{
                                font: '"Open Sans", sans-serif"',
                                letterSpacing: "-0.2px",
                            }}>
                            <Link to={"/login"} style={{ textDecoration: "none" }}>
                                {t("reset_password.back_to_login")}
                            </Link>{" "}
                        </Text>{" "}
                    </div>
                </Card>
            </Row>
        </LoginContainer>
    );
}
